import httpClient from '../httpClient';

const getFeatures =  () => httpClient.get('MainPage/LotusProp/Get').then(
  (data) => {
    // this.state.snackbar =true
    // this.state.snackbarText = 'با موفقیت انجام شد'
    return data
  }
)
  .catch(()=>{
    //

  })
const setFeatures =  (params) => httpClient.post('/MainPage/LotusProp/Post', params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const putFeatures = (params,id) => httpClient.put(`MainPage/LotusProp/Put/${id}`, params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })


export {
  getFeatures,
  setFeatures,
  putFeatures,
}
